import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import Button from "./Button";
import { ChevronIcon } from "@/assets/icons";

interface ChevronDropdownOption {
  label: string;
  value: string;
  onClick?: () => void;
  disabled?: boolean;
}

interface ChevronDropdownProps {
  label: string;
  options: ChevronDropdownOption[];
  variant?: "primary" | "secondary";
  size?: "sm" | "md" | "lg";
  align?: "left" | "right";
  disabled?: boolean;
  className?: string;
}

export default function ChevronDropdown({
  label,
  options,
  variant = "secondary",
  size = "sm",
  align = "right",
  disabled = false,
  className = "",
}: ChevronDropdownProps) {
  const anchorPosition = align === "right" ? "bottom end" : "bottom start";

  if (disabled) {
    return (
      <Button
        variant={variant}
        size={size}
        disabled
        className={`relative pr-8 ${className}`}
      >
        {label}
        <ChevronIcon
          size={12}
          className="absolute right-2 top-1/2 transform -translate-y-1/2"
          direction="down"
        />
      </Button>
    );
  }

  return (
    <Menu>
      {({ open }) => (
        <>
          <MenuButton as="div">
            <Button
              variant={variant}
              size={size}
              disabled={disabled}
              className={`relative pr-8 ${className}`}
            >
              {label}
              <ChevronIcon
                size={12}
                className="absolute right-2 top-1/2 transform -translate-y-1/2"
                direction={open ? "up" : "down"}
              />
            </Button>
          </MenuButton>
          <MenuItems
            anchor={anchorPosition}
            className="w-auto bg-white rounded-md shadow-lg border border-gray-200 py-1 z-50"
          >
            {options.map(option => (
              <MenuItem key={option.value} disabled={option.disabled}>
                <button
                  onClick={option.onClick}
                  disabled={option.disabled}
                  className="w-full text-left px-4 py-2 text-sm text-gray-700 data-focus:bg-gray-100 data-disabled:opacity-50 data-disabled:cursor-not-allowed"
                >
                  {option.label}
                </button>
              </MenuItem>
            ))}
          </MenuItems>
        </>
      )}
    </Menu>
  );
}
